export const config = {
  title: 'Dave Andrews Construction Ltd. | Excavation & Site Work in Antigonish & Cape Breton',
  meta: {
    description:
      'Dave Andrews Construction Ltd. provides professional excavation, septic installation, demolition, and site preparation services across Antigonish, Cape Breton, and surrounding areas in Nova Scotia.',
    keywords: [
      'Dave Andrews Construction',
      'Excavation Services',
      'Septic System Installation',
      'Site Preparation',
      'Demolition Contractor',
      'Cape Breton Excavation',
      'Antigonish Construction',
      'NS Construction Services',
    ],
    author: 'Dave Andrews Construction Ltd.',
    canonicalUrl: 'https://www.daveandrewsconstructionltd.com/',
  },
  sections: {
    header: {
      businessName: 'Dave Andrews Construction Ltd.',
    },
    sectionB: {
      heroTitle: 'Dave Andrews Construction Ltd.',
      heroSubtitle: 'Excavation & Construction Services Across Nova Scotia',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '19028705191',
      phoneLabel: '+1 (902) 870-5191',
      heroBackgroundImage:
        'https://static.wixstatic.com/media/fe0b8f_24bed54c1d7543588418f61f7000fc9c~mv2.jpg/v1/fill/w_456,h_342,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/202412SEP06.jpg',
      cardData: [
        {
          title: 'Excavation & Grading',
          description:
            'We offer full excavation and grading services to prepare your land for any project.',
        },
        {
          title: 'Septic Systems & Site Work',
          description:
            'We install and repair septic systems, and handle comprehensive site development.',
        },
        {
          title: 'Demolition & Hauling',
          description:
            'Safe and professional demolition services, along with material removal and hauling.',
        },
      ],
      description:
        'With decades of experience, Dave Andrews Construction Ltd. proudly serves Antigonish, Cape Breton, and beyond. From excavation to demolition, we provide reliable, top-quality work for residential and commercial clients alike.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'We specialize in construction and excavation solutions that set the foundation for long-lasting results.',
      cards: [
        {
          title: 'Excavation & Grading',
          description:
            'Land clearing, site prep, road building, grading, and more with modern equipment.',
          imageSrc: 'https://media.istockphoto.com/id/1063017648/photo/small-bulldozer-removing-grass-from-yard-preparing-for-pool-installation.jpg?s=612x612&w=0&k=20&c=H9j3HXIbuRwJHP7GNvJZ7r8ClYExWeHjmQT98f35Av4=',
          imageAlt: 'Excavation Services',
        },
        {
          title: 'Septic System Installation',
          description:
            'Certified septic system installations for residential and commercial properties.',
          imageSrc: 'https://media.istockphoto.com/id/1337506217/photo/a-worker-installs-a-sewer-manhole-on-a-septic-tank-made-of-concrete-rings-construction-of.jpg?s=612x612&w=0&k=20&c=ZVv4hamenLKCOlz1qk_80mm212XRFmde0IgEp9mA3pA=',
          imageAlt: 'Septic Installation',
        },
        {
          title: 'Demolition & Hauling',
          description:
            'Full-service demolition, debris removal, and heavy material hauling for projects of all sizes.',
          imageSrc: 'https://media.istockphoto.com/id/2187033761/photo/a-bustling-construction-site-featuring-large-heavy-machinery-and-ongoing-excavation-work.jpg?s=612x612&w=0&k=20&c=mFeW1yj6ixUEH-LWP3h5mwcLnI18OVjwvhjkEknmjoY=',
          imageAlt: 'Demolition and Hauling',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Road Construction',
        'Driveway Installation',
        'Topsoil & Gravel Delivery',
        'Utility Trenching',
        'Site Development',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/fe0b8f_70b0adff7ab24533a7c9526569269d7e~mv2.jpg/v1/fill/w_301,h_401,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/fe0b8f_70b0adff7ab24533a7c9526569269d7e~mv2.jpg',
        alt: 'Dave Andrews Construction Team',
      },
      aboutText: [
        'Dave Andrews Construction Ltd. is a trusted name in excavation and site development throughout Nova Scotia.',
        'From residential septic systems to commercial land clearing and demolition, we bring reliable service, experienced operators, and a fleet of modern equipment to every job site.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Dave Andrews Construction Ltd. Logo',
      businessName: 'Dave Andrews Construction Ltd.',
      contact: {
        phone: '19028705191',
        phoneLabel: '+1 (902) 870-5191',
        email: 'andrewsconstructionltd@outlook.com',
        website: 'https://www.daveandrewsconstructionltd.com/',
        address: 'Serving Antigonish, Cape Breton, and surrounding areas, Nova Scotia, Canada',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/profile.php?id=61559333525015',
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Antigonish, Nova Scotia, Canada',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2805.374447252377!2d-61.994026084442865!3d45.62141547910347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b59d591b3db7bcd%3A0x36b20a1c37d04bb!2sAntigonish%2C%20NS%2C%20Canada!5e0!3m2!1sen!2sca!4v1712110000000!5m2!1sen!2sca',
    },
  },
};

export default config;
